import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

const CELL_HEIGHT = 63 / 8;

export const sectionHeaderRow: SxStyleFunc<boolean> = (open) => ({
  backgroundColor: open ? (p) => p.palette.grey[100] : 'transparent',
});

export const sectionHeaderCell: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  pl: 2,
  pr: 1,
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const sectionHeaderValueCell: SxStyle = {
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '&:last-of-type': { borderRight: 0 },
};

export const coverageStack: SxStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0.5,
};

export const collapseButton: SxStyle = {
  p: 0,
};

export const collapsibleWrapperCell: SxStyle = {
  p: '0 !important',
  borderBottom: 0,
};

export const featureRow: SxStyle = {
  '& > *': { borderBottom: 'px solid', borderColor: 'divider' },
};

export const featureNameCell: SxStyle = {
  pl: 5,
  pr: 1,
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const featureValueCell: SxStyle = {
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  width: 269,
  minWidth: 269,
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '&:last-of-type': { borderRight: 0 },
};
